<template>
  <div class="ps-update-page" :class="{ 'is-ai-parsing': jxing }">
    <AiParseLoading
      v-if="jxing"
      title="正在智能识别特色文化育人品牌申报书"
      @cancel="cancelAiParse"
    />
    <div class="ps-form-layout">
      <aside class="ps-sidebar">
        <div class="ps-side-card">
          <div class="ps-side-title">填写步骤</div>
          <button
            v-for="(sec, i) in sections"
            :key="sec.id"
            type="button"
            class="ps-step-item"
            :class="sectionStepClass(i)"
            @click="editGo(i)"
          >
            <span class="ps-step-label">{{ sec.title }}</span>
            <span class="ps-step-mark">{{ sectionStepMark(i) }}</span>
          </button>
          <div class="ps-side-hint">
            点击步骤切换模块，带 <b style="color: #ef4444">*</b> 的为必填项
          </div>
        </div>
      </aside>

      <div class="ps-content">
        <div class="ps-status-bar">
          <div class="ps-status-block">
            <span class="ps-status-label">当前状态</span>
            <StatusBadge status="0" text="AI导入" type="blue" />
          </div>
          <div class="ps-status-block">
            <span class="ps-status-label">正在编辑</span>
            <span class="ps-status-value warn">识别结果编辑</span>
          </div>
          <div style="flex: 1"></div>
          <button type="button" class="ps-btn ps-btn--white" @click="saveDraft">
            💾 暂存
          </button>
          <button type="button" class="ps-btn ps-btn--blue" @click="option()">
            ✉ 提交
          </button>
          <button type="button" class="ps-btn ps-btn--white" @click="goBack">
            ↩ 返回
          </button>
        </div>

        <div
          class="ps-form-card"
          :class="{ 'is-origin-form': activeSection === 0 }"
        >
          <div v-show="activeSection === 0" id="baseInfo" class="ps-origin-base-embed">
            <BaseInfo
              :oldInfos="baseInfo"
              ref="baseInfoRef"
              @goStep="goStep"
              :isAdd="isAdd"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 1" id="teamInfo" class="ps-list-embed">
            <TeamInfo
              :oldInfos="baseInfo"
              ref="teamInfoRef"
              :cardTitle="baseInfoTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 2" id="budget" class="ps-list-embed">
            <Budget
              :oldInfos="baseInfo"
              ref="budgetRef"
              :cardTitle="budgetTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div
            v-show="activeSection === 3"
            id="capitalExpenditure"
            class="ps-list-embed"
          >
            <CapitalExpenditure
              :oldInfos="baseInfo"
              ref="capitalExpenditureRef"
              :cardTitle="capitalExpenditureTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 4" id="annualPlan" class="ps-list-embed">
            <AnnualPlan
              :oldInfos="baseInfo"
              ref="annualPlanRef"
              :cardTitle="annualPlanTitle"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 5" id="activity" class="ps-list-embed">
            <Activity
              :oldInfos="baseInfo"
              ref="activityRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div
            v-show="activeSection === 6"
            id="brandBuilding"
            class="ps-list-embed"
          >
            <BrandBuilding
              :oldInfos="baseInfo"
              ref="teamBuildingRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div
            v-show="activeSection === 7"
            id="educatingPeople"
            class="ps-list-embed"
          >
            <EducatingPeople
              :oldInfos="baseInfo"
              ref="educatingPeopleRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
              :cardTitle="educatingPeopleTitle"
            />
          </div>
          <div
            v-show="activeSection === 8"
            id="achievement"
            class="ps-list-embed"
          >
            <Achievement
              :oldInfos="baseInfo"
              ref="achievementRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
              :cardTitle="achievementTitle"
            />
          </div>
          <div
            v-show="activeSection === 9"
            id="brandPropaganda"
            class="ps-list-embed"
          >
            <Propaganda
              :oldInfos="baseInfo"
              ref="PropagandaRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
          <div v-show="activeSection === 10" id="result" class="ps-list-embed">
            <Effect
              :oldInfos="baseInfo"
              ref="resultRef"
              :isRevise="isRevise"
              @onRevise="onRevise"
            />
          </div>
        </div>

        <div class="ps-footer-bar">
          <div class="ps-footer-tip">
            💡 AI 已识别申报书内容，请核对后按步骤完善各模块
          </div>
          <div class="ps-footer-actions">
            <button type="button" class="ps-btn ps-btn--white" @click="editPrev">
              ← 上一步
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="editNext">
              下一步 →
            </button>
            <button type="button" class="ps-btn ps-btn--blue" @click="option()">
              ✉ 提交
            </button>
          </div>
        </div>
      </div>
    </div>
    <RateIcon
      ref="rateIcon"
      @onShowRateTable="onShowRateTable"
      v-if="$store.state.role === 'score-role'"
    />
    <RateTable ref="rateTable" />
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction, postAiChat } from "@/api/index";
import BaseInfo from "./baseInfo.vue";
import TeamInfo from "./teamInfo.vue";
import Budget from "./budget.vue";
import CapitalExpenditure from "./capitalExpenditure.vue";
import AnnualPlan from "./annualPlan.vue";
import Effect from "./effect.vue";
import Activity from "./activity.vue";
import BrandBuilding from "./brandBuilding.vue";
import Honor from "./honor.vue";
import Propaganda from "./propaganda.vue";
import PracticeBase from "./practiceBase.vue";
import AiParseLoading from "@/components/common/AiParseLoading.vue";
import StatusBadge from "@/components/projectShell/StatusBadge.vue";
import sectionFilledMixin from "@/components/projectShell/sectionFilledMixin.js";
import EducatingPeople from "./educatingPeople.vue";
import Achievement from "./achievement.vue";
import RateTable from "@/components/common/rateTable";
import RateIcon from "@/components/common/rateIcon";
import { BRAND, BRAND1 } from "@/utils/brand.js";
import { emptyDatesToNull, emptyToNull } from "@/utils/time";
import axios from "axios";
export default {
  mixins: [sectionFilledMixin],
  name: "",
  components: {
    BaseInfo,
    TeamInfo,
    Budget,
    CapitalExpenditure,
    Effect,
    Activity,
    BrandBuilding,
    Honor,
    Propaganda,
    PracticeBase,
    AiParseLoading,
    StatusBadge,
    AnnualPlan,
    EducatingPeople,
    Achievement,
    RateTable,
    RateIcon,
  },
  props: {
    editInfo: { type: Object, default: null },
  },
  data() {
    return {
      jxing: true,
      baseInfoTitle: "品牌团队",
      budgetTitle: "品牌资金预算",
      capitalExpenditureTitle: "品牌资金使用",
      annualPlanTitle: "年度计划",
      educatingPeopleTitle: "思政育人",
      achievementTitle: "品牌成果",
      sections: [
        {
          title: "品牌基本信息",
          id: "baseInfo",
        },
        {
          title: "品牌团队",
          id: "teamInfo",
        },
        {
          title: "品牌资金预算",
          id: "budget",
        },
        {
          title: "品牌资金使用",
          id: "capitalExpenditure",
        },
        {
          title: "年度计划",
          id: "annualPlan",
        },
        {
          title: "品牌活动",
          id: "activity",
        },
        {
          title: "品牌建设",
          id: "brandBuilding",
        },
        {
          title: "思政育人",
          id: "educatingPeople",
        },
        {
          title: "品牌成果",
          id: "achievement",
        },
        // {
        //   title: "品牌荣誉",
        //   id: "honor",
        // },
        {
          title: "品牌宣传",
          id: "brandPropaganda",
        },
        {
          title: "品牌效果",
          id: "result",
        },
        // {
        //   title: "品牌基地",
        //   id: "practiceBase",
        // },
      ],
      baseInfo: null,
      id: null,
      activeSection: 0,
      isAdd: true,
      isEdit: false,
      isRevise: false,
      isClickEdit: false,
      jblist: [],
      lblist: [],
      pplist: [],
      // jdlb:[{text:'校内基地',title:'校内基地'},{text:'校外基地',title:'校外基地'}]
      jdlb: [],
      lylist: [],
      // lylist:[{text:'省补贴',title:'省补贴'},{text:'地方补贴',title:'地方补贴'},{text:'学校自筹',title:'学校自筹'},{text:'其他',title:'其他'}],
      educationlist: [],
      zclist: [],
      contentlist: [],
      resourceCategoryList: [],
      brandAchievementsList: [],
      productTypeList: [],
      achievementLevel: [],
      contentlist: [],
      isSubmit: false,
      draftLoading: false,
      aiChatCancelSource: null,
    };
  },
  computed: {},
  watch: {
    editInfo: {
      handler(newValue, oldValue) {
        if (newValue !== null) {
          this.baseInfo = newValue;
          this.id = newValue.id;
          this.$refs.baseInfoRef.info = newValue;
          this.$refs.teamInfoRef.oldInfo = newValue;
          // 教育局全部预览 不可编辑
          if (this.$store.state.role == "education-role") {
            this.isEdit = true;
            this.editInfo.type = "preview";
            this.isRevise = false;
          } else {
            if (this.baseInfo.auditState >= 1) {
              this.isEdit = true;
              // 防止预览更改基本信息时 因监听导致禁用
              if (!this.isClickEdit) {
                this.isRevise = false;
              }
              this.editInfo.type = "preview";
              // 驳回
              if (this.baseInfo.auditState == 3) {
                this.isEdit = false;
                this.editInfo.type = "";
                this.isRevise = true;
              }
            } else {
              this.isEdit = false;
              this.editInfo.type = "";
              this.isRevise = true;
            }
          }
        } else {
          this.baseInfo = null;
          this.id = null;
          this.$refs.baseInfoRef.info = null;
          this.$refs.teamInfoRef.oldInfo = null;
          this.isEdit = false;
          this.editInfo.type = "";
          this.isRevise = true;
        }
      },
      deep: true,
    },
  },
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  created() {
    if (!this.editInfo) {
      this.isRevise = true;
    }
    console.log("index2 created this.editInfo", this.editInfo);
    // if (this.editInfo !== null) {
    //   this.baseInfo = this.editInfo;
    // }
  },
  methods: {
    ensureList(list, msg) {
      if (!list || !list.length) {
        this.$message.info(msg);
        return false;
      }
      return true;
    },
    onShowRateTable() {
      this.$refs.rateTable.init(this.baseInfo, 2);
    },
    async getjdlb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=base_type"
        );
        // console.log(res);
        if (res.code == 200) {
          this.jdlb = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }
    },
    async getedu() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=education"
        );
        // console.log(res);
        if (res.code == 200) {
          this.educationlist = res.result;
        }
      } catch (error) {
        console.error("getedu 出错:", error);
      }
    },
    async getly() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=capital_source"
        );
        console.log(res);
        if (res.code == 200) {
          this.lylist = res.result;
        }
      } catch (error) {
        console.error("getly 出错:", error);
      }
    },
    isedu(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.educationlist.length > 0) {
          let foundItem = this.educationlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getzc() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=professional"
        );
        if (res.code == 200) {
          this.zclist = res.result;
        }
      } catch (error) {
        console.error("getxl 出错:", error);
      }
    },
    iszc(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.zclist.length > 0) {
          let foundItem = this.zclist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async getcontent() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=engaged_content"
        );
        if (res.code == 200) {
          this.contentlist = res.result;
        }
      } catch (error) {
        console.error("getcontent 出错:", error);
      }
    },
    iscontent(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.contentlist.length > 0) {
          let foundItem = this.contentlist.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    isjdlb(sj) {
      if (sj == "") {
        return "";
      } else {
        if (this.jdlb.length > 0) {
          let foundItem = this.jdlb.find((item) => item.text === sj);

          if (foundItem) {
            return foundItem.text;
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
    async executeSequentially() {
      try {
        await this.getedu(); // 等待 getedu 执行完成
        console.log("getedu 执行完毕");

        await this.getzc(); // 等待 getxl 执行完成
        console.log("getxl 执行完毕");

        await this.getcontent(); // 等待 getcontent 执行完成
        console.log("getcontent 执行完毕");
        await this.getly();
        console.log("getly 执行完毕");
        await this.getlb();
        console.log("getlb 执行完毕");
        await this.getgb();
        console.log("getgb 执行完毕");
        await this.getppxg();
        console.log("getppxg 执行完毕");
        await this.getjdlb();
        console.log("getjdlb 执行完毕");
        await this.getProductTypeList();
        console.log("getProductTypeList 执行完毕");
        await this.getResourceCategoryList();
        console.log("getResourceCategoryList 执行完毕");
        await this.getBrandAchievementsList();
        console.log("getBrandAchievementsList 执行完毕");
        await this.getAchievementLevel();
        console.log("getAchievementLevel 执行完毕");
        await this.getcsnrlist();
        this.getsj();
      } catch (error) {
        console.log("发生错误:", error);
      }
    },
    async getlb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=brand_activity_type"
        );

        if (res.code == 200) {
          this.lblist = res.result;
        }
      } catch (error) {
        console.error("getlb 出错:", error);
      }
      // getAction("/baseCommon/getDictItemsByCode?code=brand_activity_type",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.lblist=res.result;
      //     console.log(this.lblist,"111111");
      // 	}
      // });
      //  this.lblist=[{text: "实践育人",title:"实践育人"},
      //         {text: "文化育人",title:"文化育人"},
      //         {text: "心理育人",title:"心理育人"},
      //         {text: "组织育人",title:"组织育人"},
      //         {text: "其他",title:"其他"},
      //         ];
    },
    async getgb() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=brand_build"
        );

        if (res.code == 200) {
          this.gblist = res.result;
        }
      } catch (error) {
        console.error("getgb 出错:", error);
      }
      //  getAction("/baseCommon/getDictItemsByCode?code=brand_build",).then((res) => {
      // 	if (res.code == 200) {
      // this.gblist=res.result;
      // this.gblist=[{text: "校本课程",title:"校本课程"},{text: "资源建设",title:"资源建设"},{text: "其他",title:"其他"}];
      // console.log(this.gblist,"111111");
      // 	}
      // });
    },
    async getppxg() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=brand_effect"
        );

        if (res.code == 200) {
          this.pplist = res.result;
        }
      } catch (error) {
        console.error("ppxg 出错:", error);
      }
      // getAction("/baseCommon/getDictItemsByCode?code=brand_effect").then(
      //   (res) => {
      //     if (res.code == 200) {
      // this.jblist = res.result;
      // this.pplist=[{text: "国家级教学成果奖",title:"国家级教学成果奖"},
      // {text: "教师获得荣誉",title:"教师获得荣誉"},
      // {text: "省级教学成果奖",title:"省级教学成果奖"},
      // {text: "品牌成果获得荣誉",title:"品牌成果获得荣誉"},
      // {text: "其他",title:"其他"},
      // ];
      //       console.log(this.jblist,"111111");
      //     }
      //   }
      // );
    },
    isYear(year) {
      if (year === null || year === undefined || year === "") return "";
      if (typeof year === "object" && !Array.isArray(year) && typeof year.year === "function") {
        const y = year.year();
        return y ? String(y) : "";
      }
      // AI 常返回 ["2022","2023","2024"]
      if (Array.isArray(year)) {
        for (let i = 0; i < year.length; i++) {
          const y = this.isYear(year[i]);
          if (y) return y;
        }
        return "";
      }
      const s = String(year).trim();
      if (/^\d{4}$/.test(s)) return s;
      const m = s.match(/(20\d{2}|19\d{2})/);
      if (m) return m[1];
      const d = new Date(year);
      return isNaN(d.getTime()) ? "" : String(d.getFullYear());
    },
    /** 取出全部合法年份（资金预算/使用跨年时展开成多行） */
    expandYears(year) {
      if (year === null || year === undefined || year === "") return [];
      if (Array.isArray(year)) {
        return year.map((y) => this.isYear(y)).filter(Boolean);
      }
      const y = this.isYear(year);
      return y ? [y] : [];
    },
    isTime(time) {
      if (!time && time !== 0) return "";
      const s = String(time).trim().replace(/[/.]/g, "-");
      const m = s.match(/^(20\d{2}|19\d{2})-(\d{1,2})-(\d{1,2})$/);
      if (!m) return "";
      const month = Number(m[2]);
      const day = Number(m[3]);
      if (month < 1 || month > 12 || day < 1 || day > 31) return "";
      return `${m[1]}-${String(month).padStart(2, "0")}-${String(day).padStart(
        2,
        "0"
      )}`;
    },
    /** 建设日期：完整日期或仅年份；支持 2021.09-2024.09 / 2018-2021 */
    parseFoundTime(val) {
      if (!val && val !== 0) return "";
      const t = this.isTime(val);
      if (t) return t;
      const s = String(val).trim();
      if (/^\d{4}$/.test(s)) return `${s}-01-01`;
      const yearRange = s.match(
        /^(20\d{2}|19\d{2})\s*[-~至到]\s*(20\d{2}|19\d{2})/
      );
      if (yearRange) return `${yearRange[1]}-01-01`;
      const ymRange = s.match(
        /^(20\d{2}|19\d{2})[.\-/](\d{1,2})\s*[-~至到]\s*(20\d{2}|19\d{2})/
      );
      if (ymRange) {
        const month = Number(ymRange[2]);
        if (month >= 1 && month <= 12) {
          return `${ymRange[1]}-${String(month).padStart(2, "0")}-01`;
        }
      }
      const ym = s.match(/^(20\d{2}|19\d{2})[.\-/](\d{1,2})$/);
      if (ym) {
        const month = Number(ym[2]);
        if (month >= 1 && month <= 12) {
          return `${ym[1]}-${String(month).padStart(2, "0")}-01`;
        }
      }
      const y = this.isYear(val);
      return y ? `${y}-01-01` : "";
    },
    /**
     * 品牌活动时间：AI 常给 年份+"12月26日"/空时间
     * 统一成 YYYY-MM-DD，供表格 holdingTime 展示
     */
    parseActivityHoldingTime(yearVal, timeVal) {
      const year = this.isYear(yearVal);
      const time = timeVal == null ? "" : String(timeVal).trim();
      if (!time) {
        return year ? `${year}-01-01` : "";
      }
      const full = this.isTime(time);
      if (full) return full;
      if (/^\d{4}[\/.]\d{1,2}[\/.]\d{1,2}$/.test(time)) {
        const p = time.split(/[\/.]/);
        return `${p[0]}-${p[1].padStart(2, "0")}-${p[2].padStart(2, "0")}`;
      }
      const md = time.match(/(\d{1,2})\s*月\s*(\d{1,2})\s*日?/);
      if (md && year) {
        return `${year}-${md[1].padStart(2, "0")}-${md[2].padStart(2, "0")}`;
      }
      if (/^\d{4}$/.test(time)) return `${time}-01-01`;
      return year ? `${year}-01-01` : "";
    },
    /** 后端 String 字段：AI 偶发返回数组时转成拼接字符串 */
    toPlainString(val, joiner = "、") {
      if (val === null || val === undefined || val === "") return "";
      if (Array.isArray(val)) {
        return val
          .map((v) => (v == null ? "" : String(v).trim()))
          .filter(Boolean)
          .join(joiner);
      }
      if (typeof val === "object") {
        try {
          return JSON.stringify(val);
        } catch (e) {
          return "";
        }
      }
      return String(val);
    },
    isly(sj) {
      if (sj == "") {
        return [""];
      } else {
        if (this.lylist.length > 0) {
          let foundItem = this.lylist.find((item) => item.text === sj);
          console.log(foundItem);
          if (foundItem) {
            return [foundItem.text];
          } else {
            return ["其他"];
          }
        } else {
          return [""];
        }
      }
    },
    extractJsonContent(content) {
      // 正则表达式匹配 JSON 内容
      const pattern = /```json(.*?)```/s; // /s 修饰符使 . 匹配换行符
      const match = content.match(pattern);
      if (match && match[1]) {
        return match[1].trim(); // 获取匹配到的 JSON 内容并去掉前后空格
      } else {
        return "No JSON content found";
      }
    },
    ispp(sj) {
      console.log("🚀 ~ ispp ~ sj:", sj);
      if (sj == "") {
        return ["", ""];
      } else {
        // console.log(this.gblist,sj);
        console.log("🚀 ~ ispp ~ this.pplist:", this.pplist);
        if (this.pplist.length > 0) {
          let foundItem = this.pplist.find((item) => item.text === sj);
          // console.log(foundItem);
          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    isgb(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        // console.log(this.gblist,sj);
        if (this.gblist && this.gblist.length > 0) {
          let foundItem = this.gblist.find((item) => item.text === sj);
          // console.log(foundItem);
          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    islb(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.lblist.length > 0) {
          let foundItem = this.lblist.find((item) => item.text === sj);

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    // 思政育人类型
    async getProductTypeList() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=Ideological_political_education_product"
        );
        if (res.code == 200) {
          this.productTypeList = res.result;
        }
      } catch (error) {
        console.error("ppxg 出错:", error);
      }
    },
    isProductTypeList(sj) {
      console.log("🚀 ~ isProductTypeList ~ sj:", sj);
      if (sj == "") {
        return ["", ""];
      } else {
        console.log(
          "🚀 ~ isProductTypeList ~ this.productTypeList:",
          this.productTypeList
        );
        if (this.productTypeList.length > 0) {
          let foundItem = this.productTypeList.find((item) => item.text === sj);
          console.log("🚀 ~ isProductTypeList ~ foundItem:", foundItem);

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    // 品牌团队 从事专业
    getcsnrlist() {
      getAction("/baseCommon/getDictItemsByCode?code=engaged_content", {}).then(
        (res) => {
          if (res.code == 200) {
            console.log(res);
            this.contentlist = res.result;
          }
        }
      );
    },
    iscsnrlist(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.contentlist.length > 0) {
          let foundItem = this.contentlist.find((item) => item.text === sj);

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    // 思政育人类别
    async getResourceCategoryList() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=resource_category"
        );
        if (res.code == 200) {
          this.resourceCategoryList = res.result;
        }
      } catch (error) {
        console.error("ppxg 出错:", error);
      }
    },
    isResourceCategoryList(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.resourceCategoryList.length > 0) {
          let foundItem = this.resourceCategoryList.find(
            (item) => item.text === sj
          );

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    // 品牌成果名称
    async getBrandAchievementsList() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=brand_achievements"
        );
        if (res.code == 200) {
          this.brandAchievementsList = res.result;
        }
      } catch (error) {
        console.error("ppxg 出错:", error);
      }
    },
    isBrandAchievementsList(sj) {
      if (sj == "") {
        return ["", ""];
      } else {
        if (this.brandAchievementsList.length > 0) {
          let foundItem = this.brandAchievementsList.find(
            (item) => item.text === sj
          );

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    // 品牌级别
    async getAchievementLevel() {
      try {
        const res = await getAction(
          "/baseCommon/getDictItemsByCode?code=achievement_level"
        );
        if (res.code == 200) {
          this.achievementLevel = res.result;
        }
      } catch (error) {
        console.error("ppxg 出错:", error);
      }
    },
    isAchievementLevel(sj) {
      console.log("🚀 ~ isAchievementLevel ~ sj:", sj);
      if (sj == "") {
        return ["", ""];
      } else {
        console.log(
          "🚀 ~ isAchievementLevel ~ this.achievementLevel:",
          this.achievementLevel
        );
        if (this.achievementLevel.length > 0) {
          let foundItem = this.achievementLevel.find(
            (item) => item.text === sj
          );

          if (foundItem) {
            return [foundItem.text, ""];
          } else {
            return ["其他", sj];
          }
        } else {
          return ["", ""];
        }
      }
    },
    // 点击编辑按钮
    onRevise() {
      this.isRevise = true;
      this.isClickEdit = true;
    },
    collectAiDraftData() {
      const baseInfoRef = this.$refs.baseInfoRef;
      const info = (baseInfoRef && baseInfoRef.info) || {};
      const fileList = (baseInfoRef && baseInfoRef.fileList) || [];
      const payload = {
        ...(this.baseInfo || {}),
        ...info,
      };
      if (fileList.length > 0) {
        payload.declarationName = fileList[0].name;
        payload.declarationPath = fileList[0].path;
      }
      if (info.promotionAddress !== undefined) {
        payload.promotionAddress = this.toPlainString(info.promotionAddress);
      }
      if (payload.applyYear) {
        payload.applyYear = this.isYear(payload.applyYear);
      }
      return payload;
    },
    saveDraft() {
      if (this.draftLoading || this.jxing) return;
      this.draftLoading = true;
      const params = this.buildBrandImportPayload();
      postAction("/aiAuto/saveDraft", params)
        .then((res) => {
          if (res.code == 200 || res.success) {
            this.isSubmit = true;
            this.applyDraftId(res);
            this.$message.success(res.message || "暂存成功");
            this.$nextTick(() => {
              this.$router.replace({ name: "educationalBrand" }).catch(() => {
                this.$router.push({ name: "educationalBrand" });
              });
            });
          } else {
            this.$message.error(res.message || "暂存失败");
          }
        })
        .finally(() => {
          this.draftLoading = false;
        });
    },
    formatFoundTime(foundTime) {
      if (!foundTime) return null;
      const dateObj = new Date(foundTime);
      if (isNaN(dateObj.getTime())) return null;
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();
      return `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
    },
    applyDraftId(res) {
      const id = res && res.result && res.result.id;
      if (!id) return;
      if (!this.baseInfo) this.baseInfo = {};
      this.baseInfo.id = id;
      if (this.$refs.baseInfoRef && this.$refs.baseInfoRef.info) {
        this.$refs.baseInfoRef.info.id = id;
      }
      const userId =
        (this.$store.state.user && this.$store.state.user.id) ||
        this.$store.state.userId;
      if (userId) {
        window.sessionStorage.setItem(`step${userId}`, id);
      }
    },
    buildBrandImportPayload() {
      const baseInfoRef = this.$refs.baseInfoRef;
      const info = (baseInfoRef && baseInfoRef.info) || {};
      const fileList = (baseInfoRef && baseInfoRef.fileList) || [];
      const base = this.baseInfo || {};
      let brandLabels = info.brandLabels;
      if (brandLabels && typeof brandLabels !== "string") {
        brandLabels = JSON.stringify(brandLabels);
      }
      let brandConnotation = info.brandConnotation || "";
      if (Array.isArray(info.keyword)) {
        brandConnotation = info.keyword.join(",");
      }
      let applyYear = info.applyYear ? this.isYear(info.applyYear) : "";
      const params = {
        ...info,
        teacherlist: [...(base.brandlist || [])],
        constructionList: [...(base.brandBuildlist || [])],
        ppActivityList: [...(base.brandActivitylist || [])],
        brandPromotionList: [...(base.brandAdvertlist || [])],
        brandEffectList: [...(base.brandEffectlist || [])],
        brandAchievementList: [...(base.achievementList || [])],
        ideologicalPoliticalEducationList: [
          ...(base.educatingPeopleList || []),
        ],
        foundTime: this.formatFoundTime(info.foundTime),
        brandLabels,
        applyYear,
        brandConnotation,
        applyType: 2,
        id: base.id || info.id,
      };
      if (fileList.length > 0) {
        params.declarationName = fileList[0].name;
        params.declarationPath = fileList[0].path;
      }
      if (params.promotionAddress !== undefined) {
        params.promotionAddress = this.toPlainString(params.promotionAddress);
      }
      emptyDatesToNull(params);
      return params;
    },
    option() {
      const baseInfoRef = this.$refs.baseInfoRef;
      // AI识别未解析到的字段是 undefined 而不是 ""，
      // 原来外层用 === "" 判断导致 undefined 时整个校验被跳过，提交时校验形同虚设
      const info = (baseInfoRef && baseInfoRef.info) || {};
      const isEmpty = (v) => v === undefined || v === null || v === "";
      if (isEmpty(info.name)) {
        this.$message.info("请填写品牌名称");
        return false;
      }
      if (isEmpty(info.applyYear)) {
        this.$message.info("请选择申报年份");
        return false;
      }
      if (isEmpty(info.belongDepartment)) {
        this.$message.info("请填写所属部门");
        return false;
      }
      if (isEmpty(info.foundTime)) {
        this.$message.info("请选择建设日期");
        return false;
      }
      if (isEmpty(info.brandClassify)) {
        this.$message.info("请选择品牌层级");
        return false;
      }
      if (!info.brandLabels || info.brandLabels.length === 0) {
        this.$message.info("请选择品牌文化");
        return false;
      }
      const hasDeclaration =
        (baseInfoRef.fileList &&
          baseInfoRef.fileList.length > 0 &&
          baseInfoRef.fileList[0] &&
          baseInfoRef.fileList[0].path) ||
        (baseInfoRef.info && baseInfoRef.info.declarationPath);
      if (!hasDeclaration) {
        this.$message.info("请上传申报书");
        return false;
      }
      const keywords = baseInfoRef.info && baseInfoRef.info.keyword;
      if (
        !keywords ||
        (Array.isArray(keywords) && keywords.length === 0) ||
        keywords === ""
      ) {
        this.$message.info("请输入品牌内涵关键词");
        return false;
      }
      if (
        !this.baseInfo.brandlist ||
        this.baseInfo.brandlist.length === 0
      ) {
        this.$message.info("请添加团队成员");
        return false;
      }
      if (this.baseInfo.brandlist.length > 0) {
        const requiredFields = [
          "teacherName",
          "sex",
          "education",
          "professionalTitle",
          "joinYear",
          "izResponse",
        ];
        for (let i = 0; i < this.baseInfo.brandlist.length; i++) {
          const item = this.baseInfo.brandlist[i];

          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "teacherName") {
                this.$message.info(
                  `品牌团队第 ${i + 1} 行的教师姓名没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "sex") {
                this.$message.info(
                  `品牌团队第 ${i + 1} 行的教师性别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "education") {
                this.$message.info(
                  `品牌团队第 ${i + 1} 行的学历没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "professionalTitle") {
                this.$message.info(
                  `品牌团队第 ${i + 1} 行的职称没有值，请填写`
                );
                return;
              } else if (field == "joinYear") {
                this.$message.info(
                  `品牌团队第 ${i + 1} 行的加入年份没有值，请填写`
                );
                return;
              } else if (field == "izResponse") {
                this.$message.info(
                  `品牌团队第 ${i + 1} 行的是否负责人没有值，请填写`
                );
                return;
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.capitalBudgetinglist, "请添加品牌资金预算"))
        return false;
      if (this.baseInfo.capitalBudgetinglist.length > 0) {
        const requiredFields = ["vintages", "capitalSource", "amount"];
        for (let i = 0; i < this.baseInfo.capitalBudgetinglist.length; i++) {
          const item = this.baseInfo.capitalBudgetinglist[i];

          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "vintages") {
                this.$message.info(
                  `品牌资金预算第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "capitalSource") {
                this.$message.info(
                  `品牌资金预算第 ${i + 1} 行的资金来源没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "amount") {
                this.$message.info(
                  `品牌资金预算第 ${i + 1} 行的资金金额没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.capitalPaylist, "请添加品牌资金使用"))
        return false;
      if (this.baseInfo.capitalPaylist.length > 0) {
        const requiredFields = [
          "lxSubsudyFundId",
          "costYear",
          "project",
          "amount",
        ];
        for (let i = 0; i < this.baseInfo.capitalPaylist.length; i++) {
          const item = this.baseInfo.capitalPaylist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "lxSubsudyFundId") {
                this.$message.info(
                  `品牌资金使用第 ${i + 1} 行的支出资金来源没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "costYear") {
                this.$message.info(
                  `品牌资金使用第 ${i + 1} 行的支出年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "project") {
                this.$message.info(
                  `品牌资金使用第 ${i + 1} 行的支出项目没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "amount") {
                this.$message.info(
                  `品牌资金使用第 ${i + 1} 行的支出金额没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.annualPlanList, "请添加年度计划"))
        return false;
      if (this.baseInfo.annualPlanList && this.baseInfo.annualPlanList.length > 0) {
        for (let i = 0; i < this.baseInfo.annualPlanList.length; i++) {
          const item = this.baseInfo.annualPlanList[i];
          if (!item.year) {
            this.$message.info(`年度计划第 ${i + 1} 行的年份没有值，请填写`);
            return false;
          }
        }
      }
      if (!this.ensureList(this.baseInfo.brandActivitylist, "请添加品牌活动"))
        return false;
      if (this.baseInfo.brandActivitylist.length > 0) {
        const requiredFields = [
          "name",
          "type",
          "location",
          "partNum",
          "personTime",
          "holdingTime",
        ];
        for (let i = 0; i < this.baseInfo.brandActivitylist.length; i++) {
          const item = this.baseInfo.brandActivitylist[i];
          // 兼容旧数据：holdTime / activityYear 也可视为有时间
          if (!item.holdingTime && (item.holdTime || item.activityYear)) {
            item.holdingTime =
              item.holdTime ||
              (String(item.activityYear).length === 4
                ? `${item.activityYear}-01-01`
                : item.activityYear);
          }
          for (let field of requiredFields) {
            if (!item[field]) {
              if (field == "name") {
                this.$message.info(
                  `品牌活动第 ${i + 1} 行的名称没有值，请填写`
                );
                return;
              } else if (field == "type") {
                this.$message.info(
                  `品牌活动第 ${i + 1} 行的类别没有值，请填写`
                );
                return;
              } else if (field == "location") {
                this.$message.info(
                  `品牌活动第 ${i + 1} 行的地点没有值，请填写`
                );
                return;
              } else if (field == "partNum") {
                this.$message.info(
                  `品牌活动第 ${i + 1} 行的人数没有值，请填写`
                );
                return;
              } else if (field == "personTime") {
                this.$message.info(
                  `品牌活动第 ${i + 1} 行的人次没有值，请填写`
                );
                return;
              } else if (field == "holdingTime") {
                this.$message.info(
                  `品牌活动第 ${i + 1} 行的时间没有值，请填写`
                );
                return;
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.brandBuildlist, "请添加品牌建设"))
        return false;
      if (this.baseInfo.brandBuildlist.length > 0) {
        const requiredFields = ["constructionYear", "name", "type", "num"];
        for (let i = 0; i < this.baseInfo.brandBuildlist.length; i++) {
          const item = this.baseInfo.brandBuildlist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "constructionYear") {
                this.$message.info(
                  `品牌建设第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "name") {
                this.$message.info(
                  `品牌建设第 ${i + 1} 行的名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "type") {
                this.$message.info(
                  `品牌建设第 ${i + 1} 行的类别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "num") {
                this.$message.info(
                  `品牌建设第 ${i + 1} 行的数量没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.educatingPeopleList, "请添加思政育人"))
        return false;
      if (this.baseInfo.educatingPeopleList.length > 0) {
        const CULTURAL_MATERIAL = "文化素材类的数字资源建设数量";
        for (let i = 0; i < this.baseInfo.educatingPeopleList.length; i++) {
          const item = this.baseInfo.educatingPeopleList[i];
          if (!item.productType) {
            this.$message.info(`思政育人第 ${i + 1} 行的类型没有值，请填写`);
            return false;
          }
          if (!item.resourceCategory) {
            const nameLabel =
              item.productType === CULTURAL_MATERIAL ? "类别" : "名称";
            this.$message.info(
              `思政育人第 ${i + 1} 行的${nameLabel}没有值，请填写`
            );
            return false;
          }
          // 数量仅「文化素材类的数字资源建设数量」展示且必填；校本读本等不校验数量
          if (
            item.productType === CULTURAL_MATERIAL &&
            (item.resourceNum === null ||
              item.resourceNum === undefined ||
              item.resourceNum === "")
          ) {
            this.$message.info(`思政育人第 ${i + 1} 行的数量没有值，请填写`);
            return false;
          }
        }
      }
      if (!this.ensureList(this.baseInfo.achievementList, "请添加品牌成果"))
        return false;
      if (
        this.baseInfo.achievementList &&
        this.baseInfo.achievementList.length > 0
      ) {
        const requiredFields = [
          "achievementName",
          "achievementNum",
          "name",
          "achievementDepart",
          "achievementStartTime",
          "achievementLevel",
          "achievementEndTime",
          "fundingAmount",
        ];
        for (let i = 0; i < this.baseInfo.achievementList.length; i++) {
          const item = this.baseInfo.achievementList[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "achievementName") {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (field == "achievementNum") {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的数量没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (item.achievementName == "教改" && field == "name") {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的项目名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "教改" &&
                field == "achievementDepart"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的立项单位没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "教改" &&
                field == "achievementStartTime"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的立项时间没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "教改" &&
                field == "achievementLevel"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的项目级别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "教改" &&
                field == "achievementEndTime"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的结项时间没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (item.achievementName == "教改" && field == "fundingAmount") {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的资助金额没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (item.achievementName == "课程申报" && field == "name") {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的课程名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "课程申报" &&
                field == "achievementLevel"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的认定级别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "课程申报" &&
                field == "achievementStartTime"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的认定时间没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (item.achievementName == "教学成果" && field == "name") {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的成果名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "教学成果" &&
                field == "achievementLevel"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的级别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
              if (
                item.achievementName == "教学成果" &&
                field == "achievementStartTime"
              ) {
                this.$message.info(
                  `品牌成果第 ${i + 1} 行的时间没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.brandAdvertlist, "请添加品牌宣传"))
        return false;
      if (this.baseInfo.brandAdvertlist.length > 0) {
        const requiredFields = [
          "addYear",
          "publicationNum",
          "clickNum",
          "focusNum",
          "smallCourseNum",
          "collegesStudentNum",
        ];
        for (let i = 0; i < this.baseInfo.brandAdvertlist.length; i++) {
          const item = this.baseInfo.brandAdvertlist[i];
          console.log("🚀 ~ option ~ item:", item);
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            console.log("🚀 ~ option ~ requiredFields:", requiredFields);
            console.log("🚀 ~ option ~ field:", field);
            console.log("🚀 ~ option ~ item[field]:", item[field]);
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "addYear") {
                this.$message.info(
                  `品牌宣传第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (
                field == "publicationNum" &&
                item.publicationNum != 0
              ) {
                this.$message.info(
                  `品牌宣传第 ${i + 1} 行的发文数量没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "clickNum" && item.clickNum != 0) {
                this.$message.info(
                  `品牌宣传第 ${i + 1} 行的点击量没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "focusNum" && item.focusNum != 0) {
                this.$message.info(
                  `品牌宣传第 ${i + 1} 行的关注人数没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (
                field == "smallCourseNum" &&
                item.smallCourseNum != 0
              ) {
                this.$message.info(
                  `品牌宣传第 ${i + 1} 行的微课开发没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (
                field == "collegesStudentNum" &&
                item.collegesStudentNum != 0
              ) {
                this.$message.info(
                  `品牌宣传第 ${i + 1} 行的院校交流学习次数没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      if (!this.ensureList(this.baseInfo.brandEffectlist, "请添加品牌效果"))
        return false;
      if (this.baseInfo.brandEffectlist.length > 0) {
        const requiredFields = ["addYear", "award", "type", "num"];
        for (let i = 0; i < this.baseInfo.brandEffectlist.length; i++) {
          const item = this.baseInfo.brandEffectlist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "addYear") {
                this.$message.info(
                  `品牌效果第 ${i + 1} 行的年份没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "award") {
                this.$message.info(
                  `品牌效果第 ${i + 1} 行的名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "type") {
                this.$message.info(
                  `品牌效果第 ${i + 1} 行的类别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "num") {
                this.$message.info(
                  `品牌效果第 ${i + 1} 行的个数没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }

      if (this.baseInfo.brandBaselist.length > 0) {
        const requiredFields = [
          "baseName",
          "baseFoundTime",
          "baseType",
          "province",
          "city",
          "area",
          "baseAddress",
        ];
        for (let i = 0; i < this.baseInfo.brandBaselist.length; i++) {
          const item = this.baseInfo.brandBaselist[i];
          // 检查每个字段是否有值
          for (let field of requiredFields) {
            if (!item[field]) {
              // 如果字段为空，弹出提示并退出循环
              if (field == "baseName") {
                this.$message.info(
                  `品牌基地第 ${i + 1} 行的基地名称没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "baseFoundTime") {
                this.$message.info(
                  `品牌基地第 ${i + 1} 行的基地建设时间没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "baseType") {
                this.$message.info(
                  `品牌基地第 ${i + 1} 行的基地类别没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "province") {
                this.$message.info(`品牌基地第 ${i + 1} 行的省没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "city") {
                this.$message.info(`品牌基地第 ${i + 1} 行的市没有值，请填写`);
                return; // 退出当前函数，停止进一步处理
              } else if (field == "area") {
                this.$message.info(
                  `品牌基地第 ${i + 1} 行的区/县没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              } else if (field == "baseAddress") {
                this.$message.info(
                  `品牌基地第 ${i + 1} 行的基地建设地址没有值，请填写`
                );
                return; // 退出当前函数，停止进一步处理
              }
            }
          }
        }
      }
      // console.log(this.baseInfo,this.$refs.baseInfoRef.tags);
      const params = this.buildBrandImportPayload();
      console.log(params);
      this.loading = true;
      postAction("/aiAuto/autoImport", params).then((res) => {
        if (res.code == 200) {
          this.isSubmit = true;
          this.$message.success("提交成功");
          this.$router.replace({ name: "educationalBrand" }).catch(() => {
            this.$router.push({ name: "educationalBrand" });
          });
          // console.log("haole");
        } else {
          this.$message.info(res.message);
        }
        this.loading = false;
      });
    },
    isNumber(value) {
      console.log("🚀 ~ isNumber ~ value:", value);
      if (/^-?\d+(\.\d+)?$/.test(value)) {
        return value;
      } else {
        return "";
      }
    },
    goStep(item) {
      this.baseInfo = item;
      this.editInfo = item;
    },
    editGo(index) {
      this.activeSection = index;
      this.$nextTick(() => this.refreshSectionFilled());
    },
    editPrev() {
      if (this.activeSection > 0) {
        this.editGo(this.activeSection - 1);
      }
    },
    editNext() {
      if (this.activeSection < this.sections.length - 1) {
        this.editGo(this.activeSection + 1);
      }
    },
    goBack() {
      this.$router.push({ name: "educationalBrand" });
    },
    // 获取暂存数据
    getTemporaryStorage() {
      postAction("/lx/lxApply/getAiData?applyType=2").then((res) => {
        console.log("res", res);
        if (res.code == 200) {
          const result = res.result.jsonObject;
          console.log("result", result);
          this.baseInfo = result;
          this.jxing = false;
        }
      });
    },
    getsj() {
      if (this.$route.query.new == "ai") {
        this.jxing = true;
        if (this.aiChatCancelSource) {
          this.aiChatCancelSource.cancel("restart");
        }
        this.aiChatCancelSource = axios.CancelToken.source();
        postAiChat(
          {
            fileId: this.fileId,
            applyType: 2,
            chatType: this.$route.query.chatType,
            filePath: this.$route.query.filePath,
          },
          { cancelToken: this.aiChatCancelSource.token }
        ).then((res) => {
          //const res = BRAND1;
          console.log("🚀 ~ getsj ~ res:", res);
          console.log("🚀 ~ getsj ~ res.code:", res && res.code);
          if (res && res.code == 200) {
            // console.log(JSON.parse(str));
            // this.sj=JSON.parse(this.extractJsonContent(JSON.parse(str).output.choices[0].message.content));
            let str = res.result;
            // this.sj = JSON.parse(this.extractJsonContent(str));
            this.sj = str;
            console.log(this.sj);
            let datas = {
              name: "",
              applyYear: "",
              brandClassify: "",
              brandLabels: [],
              belongDepartment: "",
              foundTime: "",
              brandlist: [],
              applyType: 2,
              weChatPublicAccount: "",
              promotionAddress: "",
              brandExposureRate: "",
              goodRate: "",
              teacherParticipationRate: "",
              studentParticipationRate: "",
              brandConnotation: "",
              declarationName: "",
              declarationPath: "",
              brandActivitylist: [],
              brandBuildlist: [],
              brandAdvertlist: [],
              brandEffectlist: [],
              brandBaselist: [],
              annualPlanList: [],
              achievementList: [],
              capitalBudgetinglist: [],
              capitalPaylist: [],
              educatingPeopleList: [],
            };
            datas.name = this.sj.品牌基本信息.品牌名称;
            datas.applyYear = this.sj.品牌基本信息.申报年份
              ? this.isYear(this.sj.品牌基本信息.申报年份)
              : "";
            datas.belongDepartment = this.sj.品牌基本信息.所属部门
              ? this.sj.品牌基本信息.所属部门
              : "";
            datas.foundTime = this.sj.品牌基本信息.建设日期
              ? emptyToNull(this.parseFoundTime(this.sj.品牌基本信息.建设日期))
              : null;
            datas.brandClassify = this.sj.品牌基本信息.品牌层级
              ? this.sj.品牌基本信息.品牌层级
              : "";
            datas.brandLabels = this.sj.品牌基本信息.品牌文化
              ? this.sj.品牌基本信息.品牌文化
              : "";
            datas.weChatPublicAccount = this.sj.品牌基本信息.品牌公众号
              ? this.sj.品牌基本信息.品牌公众号
              : "";
            datas.promotionAddress = this.toPlainString(
              this.sj.品牌基本信息.宣传地址
            );
            datas.brandExposureRate = this.sj.品牌基本信息.品牌熟知率
              ? this.isNumber(this.sj.品牌基本信息.品牌熟知率)
              : "";
            datas.goodRate = this.sj.品牌基本信息.好评率
              ? this.isNumber(this.sj.品牌基本信息.好评率)
              : "";
            datas.teacherParticipationRate = this.sj.品牌基本信息.教师参与率
              ? this.isNumber(this.sj.品牌基本信息.教师参与率)
              : "";
            datas.studentParticipationRate = this.sj.品牌基本信息.学生参与率
              ? this.isNumber(this.sj.品牌基本信息.学生参与率)
              : "";
            datas.brandConnotation = this.sj.品牌基本信息.品牌内涵
              ? this.sj.品牌基本信息.品牌内涵
              : "";
            datas.declarationName = this.$route.query.fileName;
            datas.declarationPath = this.$route.query.filePath;
            if (this.sj.品牌团队 && this.sj.品牌团队.length > 0) {
              datas.brandlist = this.sj.品牌团队.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    teacherName:
                      student.教师姓名 == undefined ? "" : student.教师姓名,
                    id: student.教师姓名 + index,
                    sex: student.性别 == undefined ? "男" : student.性别,
                    education:
                      student.学历 == undefined ? "" : this.isedu(student.学历),
                    professionalTitle:
                      student.职称 == undefined ? "" : this.iszc(student.职称),
                    engagedContent:
                      student.从事内容 == undefined
                        ? ""
                        : this.iscontent(student.从事内容),
                    joinYear:
                      student.加入年份 == undefined
                        ? ""
                        : this.isYear(student.加入年份),
                    primaryMission:
                      student.主要任务 == undefined ? "" : student.主要任务,
                    izResponse:
                      student.是否负责人 == undefined
                        ? "否"
                        : student.是否负责人,
                    // engagedContent:
                    //   student.从事专业 == undefined
                    //     ? "否"
                    //     : this.iscsnrlist(student.从事专业),
                  });
                  return accumulator;
                },
                []
              );
            }

            if (this.sj.品牌资金预算 && this.sj.品牌资金预算.length > 0) {
              datas.capitalBudgetinglist = this.sj.品牌资金预算.reduce(
                (accumulator, student, index) => {
                  const years = this.expandYears(student.年份);
                  const yearList = years.length ? years : [""];
                  yearList.forEach((y, yi) => {
                    accumulator.push({
                      capitalSource:
                        student.资金来源 == undefined
                          ? ""
                          : this.isly(student.资金来源)[0],
                      id:
                        this.isly(student.资金来源)[0] +
                        student.资金金额 +
                        index +
                        "_" +
                        yi,
                      amount:
                        student.资金金额 == undefined
                          ? ""
                          : this.isNumber(student.资金金额),
                      vintages: y,
                    });
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌资金使用 && this.sj.品牌资金使用.length > 0) {
              datas.capitalPaylist = this.sj.品牌资金使用.reduce(
                (accumulator, student, index) => {
                  const years = this.expandYears(student.支出年份);
                  const yearList = years.length ? years : [""];
                  yearList.forEach((y, yi) => {
                    accumulator.push({
                      lxSubsudyFundId:
                        student.支出资金来源 == undefined
                          ? ""
                          : this.isly(student.支出资金来源)[0],
                      costYear: y,
                      amount:
                        student.支出金额 == undefined
                          ? ""
                          : this.isNumber(student.支出金额),
                      project:
                        student.支出项目 == undefined ? "" : student.支出项目,
                      id: (student.支出项目 || "pay") + index + "_" + yi,
                    });
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.年度计划 && this.sj.年度计划.length > 0) {
              datas.annualPlanList = this.sj.年度计划.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    lxSubsudyFundId:
                      student.支出资金来源 == undefined
                        ? ""
                        : this.isly(student.支出资金来源)[0],
                    costYear:
                      student.支出年份 == undefined
                        ? ""
                        : this.isYear(student.支出年份),
                    amount:
                      student.支出金额 == undefined
                        ? ""
                        : this.isNumber(student.支出金额),
                    project:
                      student.支出项目 == undefined ? "" : student.支出项目,
                    id: student.支出项目 + index,
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌活动 && this.sj.品牌活动.length > 0) {
              datas.brandActivitylist = this.sj.品牌活动.reduce(
                (accumulator, student, index) => {
                  const holdingTime = this.parseActivityHoldingTime(
                    student.年份,
                    student.时间
                  );
                  const activityYear =
                    this.isYear(student.年份) ||
                    (holdingTime ? String(holdingTime).slice(0, 4) : "");
                  accumulator.push({
                    type:
                      student.类别 == undefined
                        ? ""
                        : this.islb(student.类别)[0],
                    otherType:
                      student.类别 == undefined
                        ? ""
                        : this.islb(student.类别)[1],
                    activityYear,
                    holdingTime,
                    name: student.名称 == undefined ? "" : student.名称,
                    partNum:
                      student.人数 === undefined || student.人数 === ""
                        ? ""
                        : this.isNumber(student.人数),
                    personTime:
                      student.人次 === undefined || student.人次 === ""
                        ? ""
                        : this.isNumber(student.人次),
                    location: student.地点 == undefined ? "" : student.地点,
                    content:
                      student.活动主题 == undefined ? "" : student.活动主题,
                    id: (student.名称 || "act") + index,
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌建设 && this.sj.品牌建设.length > 0) {
              datas.brandBuildlist = this.sj.品牌建设.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    type:
                      student.类别 == undefined
                        ? ""
                        : this.isgb(student.类别)[0],
                    otherType:
                      student.类别 == undefined
                        ? ""
                        : this.isgb(student.类别)[1],
                    constructionYear:
                      student.年份 == undefined
                        ? ""
                        : this.isYear(student.年份),
                    name: student.名称 == undefined ? "" : student.名称,
                    num:
                      student.数量 == undefined
                        ? ""
                        : this.isNumber(student.数量),
                    id: student.名称 + index,
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.思政育人 && this.sj.思政育人.length > 0) {
              datas.educatingPeopleList = this.sj.思政育人.reduce(
                (accumulator, student, index) => {
                  console.log("🚀 ~ getsj ~ student:", student);
                  accumulator.push({
                    productType:
                      student.类型 == undefined
                        ? ""
                        : this.isProductTypeList(student.类型)[0],
                    resourceCategory:
                      student.类型 == "undefined"
                        ? ""
                        : student.类型 == "文化素材类的数字资源建设数量"
                        ? this.isResourceCategoryList(student.类别)[0]
                        : student.名称,
                    resourceNum:
                      student.数量 == undefined
                        ? ""
                        : this.isNumber(student.数量),

                    id: student.名称 + index,
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌成果 && this.sj.品牌成果.length > 0) {
              datas.achievementList = this.sj.品牌成果.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    achievementName:
                      student.类别名称 == undefined
                        ? ""
                        : this.isBrandAchievementsList(student.类别名称)[0],
                    achievementNum:
                      student.数量 == undefined
                        ? ""
                        : this.isNumber(student.数量),
                    name: student.名称 == undefined ? "" : student.名称,
                    achievementLevel:
                      student.级别 == undefined
                        ? ""
                        : this.isAchievementLevel(student.级别)[0],
                    achievementStartTime:
                      student.立项时间 == undefined
                        ? null
                        : emptyToNull(this.isTime(student.立项时间)),

                    id: index,
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌宣传 && this.sj.品牌宣传.length > 0) {
              datas.brandAdvertlist = this.sj.品牌宣传.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    publicationNum:
                      student.发文数量 == undefined
                        ? ""
                        : this.isNumber(student.发文数量),
                    clickNum:
                      student.点击量 == undefined
                        ? ""
                        : this.isNumber(student.点击量),
                    addYear:
                      student.发文年份 == undefined
                        ? ""
                        : this.isYear(student.发文年份),
                    focusNum:
                      student.关注人数 == undefined
                        ? ""
                        : this.isNumber(student.关注人数),
                    smallCourseNum:
                      student.微课开发 == undefined
                        ? ""
                        : this.isNumber(student.微课开发),
                    collegesStudentNum:
                      student.院校交流学习次数 == undefined
                        ? ""
                        : this.isNumber(student.院校交流学习次数),
                    channelCarrier:
                      student.官宣渠道载体 == undefined
                        ? ""
                        : student.官宣渠道载体,
                    id:
                      student.点击量 +
                      index +
                      Math.random().toString(36).substring(2),
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌效果 && this.sj.品牌效果.length > 0) {
              datas.brandEffectlist = this.sj.品牌效果.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    award: student.名称 == undefined ? "" : student.名称,
                    type:
                      student.类别 == undefined
                        ? ""
                        : this.ispp(student.类别)[0],
                    otherTypee:
                      student.类别 == undefined
                        ? ""
                        : this.ispp(student.类别)[1],
                    addYear:
                      student.年份 == undefined
                        ? ""
                        : this.isYear(student.年份),
                    num:
                      student.个数 == undefined
                        ? ""
                        : this.isNumber(student.个数),
                    id: student.名称 + index,
                  });
                  return accumulator;
                },
                []
              );
            }
            if (this.sj.品牌基地 && this.sj.品牌基地.length > 0) {
              datas.brandBaselist = this.sj.品牌基地.reduce(
                (accumulator, student, index) => {
                  accumulator.push({
                    baseName:
                      student.基地名称 == undefined ? "" : student.基地名称,
                    baseFoundTime:
                      student.基地建设时间 == undefined
                        ? null
                        : emptyToNull(this.isTime(student.基地建设时间)),
                    province: student.省 == undefined ? "" : student.省,
                    city: student.市 == undefined ? "" : student.市,
                    area: student.区 == undefined ? "" : student.区,
                    baseAddress:
                      student.基地建设地址 == undefined
                        ? ""
                        : student.基地建设地址,
                    id: student.基地名称 + index,
                    // content: student.内容 == undefined ? "" : student.内容,
                    baseType:
                      student.基地类别 == undefined
                        ? ""
                        : this.jdlb(student.基地类别),
                    coverImg: "",
                    content: "",
                  });
                  return accumulator;
                },
                []
              );
            }
            // this.editInfo=datas;
            this.baseInfo = datas;
            console.log(this.baseInfo, "xiang");
            // console.log(this.baseInfo, "xiang");
          } else {
            this.$message.error(
              (res && res.message) || "智能识别失败，请稍后重试"
            );
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            return;
          }
          console.error("AI识别失败:", err);
          const msg =
            (err && err.message) ||
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.message) ||
            "智能识别失败，请稍后重试";
          this.$message.error(msg);
          this.$router.go(-1);
        })
        .finally(() => {
          this.aiChatCancelSource = null;
          this.jxing = false;
        });
      }
    },
    cancelAiParse() {
      if (this.aiChatCancelSource) {
        this.aiChatCancelSource.cancel("user_cancel");
        this.aiChatCancelSource = null;
      }
      this.jxing = false;
      this.$message.info("已取消智能识别");
      this.$router.go(-1);
    },
    // 滚动监听
    updateActiveSection() {
      this.sections.forEach((section, index) => {
        const element = document.getElementById(section.id);
        if (
          element.getBoundingClientRect().top <= 100 &&
          element.getBoundingClientRect().top >= 0
        ) {
          this.activeSection = index;
        }
      });
    },
  },
  mounted() {
    //console.log("index2 mounted this.editInfo", this.editInfo);
    this.fileId = this.$route.query.id;
    this.isAdd = this.$route.query.new == "new";
    // if (this.editInfo !== null) {
    //   this.step1 = this.editInfo;
    //   this.baseInfo = this.editInfo;
    //   this.id = this.editInfo.id;
    //   this.$refs.baseInfoRef.info = this.editInfo;
    //   this.$refs.teamInfoRef.oldInfo = this.editInfo;
    // }
    // 有id 是ai导入  无id 是暂存数据
    if (this.$route.query.new == "ai" && this.$route.query.id) {
      this.executeSequentially();
    } else {
      this.getTemporaryStorage();
    }
  },
  beforeDestroy() {
    if (this.aiChatCancelSource) {
      this.aiChatCancelSource.cancel("leave");
      this.aiChatCancelSource = null;
    }
    const baseInfoRef = this.$refs.baseInfoRef;
    if (!this.isSubmit && baseInfoRef && baseInfoRef.info) {
      postAction("/lx/lxApply/saveAiData?applyType=2", {
        jsonObject: this.collectAiDraftData(),
      }).then((res) => {
        if (res.code == 200) {
          //this.$message.success("暂存成功");
        }
      });
    }
  },
};
</script>
  
<style scoped lang="scss">
@import "@/components/projectShell/updatePage.scss";

.ps-update-page.is-ai-parsing {
  min-height: 560px;
  position: relative;
}
</style>
  